import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Bell, Images, Users, UserCog, Settings, LogOut, LayoutDashboard, ExternalLink } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/notices", label: "Notices", icon: Bell },
  { to: "/admin/gallery", label: "Gallery Events", icon: Images },
  { to: "/admin/executives", label: "Executive Body", icon: UserCog },
  { to: "/admin/members", label: "Bar Directory", icon: Users },
  { to: "/admin/settings", label: "Site Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const nav = useNavigate();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#5A6270]">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-[#FAF7F0]" data-testid="admin-layout">
      <aside className="w-64 bg-[#061733] text-[#d8c9a8] flex flex-col shrink-0">
        <div className="p-5 flex items-center gap-3 border-b border-[#123056]">
          <img src="/logo.jpg" alt="emblem" className="w-10 h-10 rounded-full object-cover" />
          <div className="font-display text-white font-semibold leading-tight text-sm">HCABA<br/>Admin</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-[#123B7A] text-white" : "hover:bg-white/5"}`}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <l.icon size={17} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#123056] space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm hover:bg-white/5"><ExternalLink size={16} /> View Website</a>
          <button onClick={() => { logout(); nav("/admin/login"); }} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm hover:bg-white/5 text-[#f0c14b]" data-testid="admin-logout"><LogOut size={16} /> Logout</button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="bg-white border-b border-[#E5DECF] px-6 py-4 flex items-center justify-between">
          <h1 className="font-display text-xl text-[#0B2E63] font-bold">Content Management</h1>
          <div className="text-sm text-[#5A6270]">{user.email}</div>
        </header>
        <div className="p-6"><Outlet /></div>
      </div>
    </div>
  );
}
